module.exports = __webpack_public_path__ + "img/record-circle.eef776c1.svg";